$('[data-role="close"]').on('click', function(e) {
	e.preventDefault();
	$('.js-menu').animate({
		left: '-1100px'
	}, 300);
	
	$('.header__menu').siblings().removeAttr('style');
	$('body').removeClass('no-scroll');
    $(this).closest('.section').removeClass('menu-scroll');
})

$('[data-rol="delete-form"]').on('click', function() {
	var form = $(this).parent();
	form.addClass('hidden');
	$('.js-form-duplication').show();

	$('[data-rol="delete-form"]').each(function(index, value) {
		$(this).addClass('hidden');
	});
})

$('[data-role="close-menu-card-color"]').on('click', function(e) {
	e.preventDefault();
	$('.js-menu-color').animate({
		right: '-1800px'
	}, 500);

	$('body').removeClass('no-scroll');
	$('.card-color__menu').removeClass('menu-scroll');

	setTimeout(function() {
		$('.card-color__menu').addClass('hidden');
	}, 500)
	
})